import React from 'react'
import usePatternCopilotHost from './hooks/usePatternCopilotHost'
import useCopilotSession from './hooks/useCopilotSession'
import CopilotPanel from './CopilotPanel'

/** The pattern editor's AI Builder as a side-panel tab. Keep this component
 * MOUNTED across tab switches (hide with display:none) so the conversation
 * survives; key it by pattern id so sessions don't leak across patterns. */
const PatternCopilotTab: React.FC = () => {
  const host = usePatternCopilotHost()
  const session = useCopilotSession(host)
  return <CopilotPanel host={host} session={session} />
}

export default PatternCopilotTab
